import { Target, Clock, Users } from 'lucide-react'
import AnimatedSection, { StaggerContainer, StaggerItem } from '@/components/AnimatedSection'

const features = [
  {
    icon: Target,
    title: 'Precision & Accuracy',
    description:
      'We use state-of-the-art GPS, total stations, and drone technology to ensure the highest level of accuracy in every survey.',
  },
  {
    icon: Clock,
    title: 'Timely Delivery',
    description:
      'We understand project timelines and strive to complete all surveys on schedule without compromising on quality.',
  },
  {
    icon: Users,
    title: 'Expert Team',
    description:
      'Our team consists of licensed professionals with decades of combined experience in various surveying disciplines.',
  },
]

export default function WhyChooseUs() {
  return (
    <section className="bg-cream py-20 lg:py-24">
      <div className="section-padding mx-auto max-w-7xl">
        <div className="grid gap-6 lg:grid-cols-[0.78fr_1.22fr] lg:gap-8">
          <AnimatedSection className="h-full">
            <div className="flex h-full flex-col justify-between rounded-2xl bg-black p-8 text-white sm:p-10">
              <div>
                <span className="inline-flex rounded-full bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent">
                  Why Choose Us
                </span>
                <h2 className="mt-6 text-3xl font-semibold leading-tight font-serif sm:text-4xl">
                  The Advict Advantage
                </h2>
                <p className="mt-5 max-w-sm text-sm leading-7 text-neutral-300">
                  We combine expertise, technology, and dedication to deliver surveying services
                  that consistently exceed expectations.
                </p>
              </div>
            </div>
          </AnimatedSection>

          <StaggerContainer className="grid gap-4 sm:grid-cols-3">
            {features.map((feature, index) => (
              <StaggerItem key={feature.title}>
                <div className="group h-full rounded-2xl bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                  <div className="mb-6 flex items-center justify-between">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent/25 text-black">
                    <feature.icon className="h-5 w-5" />
                  </div>
                  <span className="text-xs font-semibold text-neutral-300 group-hover:text-accent-dark">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="mb-2 text-lg font-semibold text-black font-serif">
                  {feature.title}
                </h3>
                <p className="text-sm leading-6 text-neutral-600">
                  {feature.description}
                </p>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
        </div>
      </div>
    </section>
  )
}
